import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getCustomerBookingList = createAsyncThunk(
  "customerBookingList/getCustomerBookingList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/customer/get_all_data`,
        data,

        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const customerBookingSlice = createSlice({
  name: "customerBookingList",
  initialState: {
    loading: false,
    customerBookingData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerBookingList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCustomerBookingList.fulfilled, (state, action) => {
        state.loading = false;
        state.customerBookingData = action.payload;
      })
      .addCase(getCustomerBookingList.rejected, (state, action) => {
        state.loading = false;
        state.customerBookingData = action.payload;
        state.error = action.payload;
      });
  },
});

export default customerBookingSlice.reducer;
